module.exports = __webpack_public_path__ + "static/media/devices_mobile.01bcbd22.png";